export default "__VITE_PUBLIC_ASSET__b2b8c5c7__"